import { Container, Grid, makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import NotFountImage from '../../assets/images/404.svg';
import Footer from '../../components/footer';
import Header from '../../components/header';
import { COLORS } from '../../constants/colors';
import { NOT_FOUNT_PAGE } from '../../constants/props';

const useStyles = makeStyles({
  root: {
    backgroundColor: COLORS.grayScale[3],
  },
  container: {
    maxWidth: '90rem',
  },
  grid: {
    height: 'calc(100vh - 303px)',
  },
  message: {
    marginTop: '6.1875rem',
    fontSize: '2.5rem',
    lineHeight: '2.9375rem',
    width: '35.125rem',
  },
});

const NotFoundPage = ({ message }) => {
  const classes = useStyles();
  return (
    <>
      <Header />
      <section className={classes.root}>
        <Container className={classes.container}>
          <Grid
            className={classes.grid}
            container
            justify="center"
            alignItems="center"
            direction="column"
          >
            <img src={NotFountImage} alt="Not Found" />
            {message && (
              <Typography
                className={classes.message}
                variant="h5"
                component="h1"
              >
                {message}
              </Typography>
            )}
          </Grid>
        </Container>
      </section>
      <Footer withInterview={false} />
    </>
  );
};

NotFoundPage.defaultProps = {
  message: null,
};
NotFoundPage.propTypes = {
  NOT_FOUNT_PAGE,
};

export default NotFoundPage;
